import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'app/rootReducer'
import UserProfileEditForm from 'components/organisms/UserProfileEditForm'
import GoBackHeader from 'components/organisms/GoBackHeader'
import {
  UPDATE_ACCOUNT,
  UpdateAccountResponse,
  UpdateAccountResponseData,
  UpdateAccountVariables
} from 'share/mutations/account'
import { setAuthentication } from 'reducers/authentication/authenticationSlice'
import {
  loadAuthenticationFromInput,
  getInitializedUpdateAccountResponseData,
  loadResultWithData
} from 'share/utils/utils'

interface Props {
  nextPage(page: string): void
  previousPage(page: string): void
}

const UserProfileEdit = (props: Props): JSX.Element => {
  const { nextPage, previousPage } = props
  const [submitErrorMessage, setSubmitErrorMessage] =
    useState<string | null>(null)
  const authentication = useSelector((state: RootState) => state.authentication)
  const dispatch = useDispatch()
  const [updateAccount] =
    useMutation<UpdateAccountResponse, UpdateAccountVariables>(UPDATE_ACCOUNT)

  function updateTheReduxStoreWithAuthenticationInfo(
    input: UpdateAccountResponseData
  ): void {
    const updatedAuthentication = loadAuthenticationFromInput(
      input,
      authentication
    )

    // updating the profile looses the account creation step so get it from authentication before replacing it with the updated authentication.
    if (updatedAuthentication.account) {
      if (authentication.account) {
        updatedAuthentication.account.accountCreationStep =
          authentication.account.accountCreationStep
      }
    }

    dispatch(setAuthentication(updatedAuthentication))
    //   console.log('updateTheRedux store user after dispatch')
  }

  async function updateAccountHelper(
    account: UpdateAccountVariables
  ): Promise<UpdateAccountResponseData> {
    const result = getInitializedUpdateAccountResponseData()

    try {
      console.log('account to update is', account)
      const updateAccountResult = await updateAccount({
        variables: account
      })

      if (updateAccountResult.data?.accounts.update.id) {
        loadResultWithData(result, updateAccountResult.data?.accounts.update)
        updateTheReduxStoreWithAuthenticationInfo(result)
      } else {
        result.success = false
        result.error = 'error occurred saving account data'
      }
    } catch (e) {
      //    console.log('error is', e)
      result.success = false
      result.error = 'error occurred saving account data. Please try again.'
    }
    //   console.log('update account result is ', result)
    return result
  }

  return (
    <React.Fragment>
      <GoBackHeader
        text='My Profile'
        onClick={() => props.previousPage('read-only')}
      />
      <div>
        <div className='default-size-container mt-4 mt-lg-5'>
          <UserProfileEditForm
            authentication={authentication}
            nextPage={nextPage}
            previousPage={previousPage}
            updateAccountHelper={updateAccountHelper}
            submitErrorMessage={submitErrorMessage}
            setSubmitErrorMessage={setSubmitErrorMessage}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default UserProfileEdit
